import AbstractAPI from '@/services/api/AbstractAPI';

export default class PageApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options);
  }

  getPageContent = async function(languageIsoCode = 'en') {
    return this.makeFileSystemRequest(process.env.BASE_URL + `assets/json/pages_${languageIsoCode}.json`, 'get');
  };

  getFaqContent = async function() {
    return this.makeFileSystemRequest(process.env.BASE_URL + 'assets/json/faq.json', 'get');
  };
}
